import {
  TOGGLE_FAVORITE,
  FETCH_FAVORITE_INVENTORY,
  DELETE_FAVORITES,
} from "../constants/actionTypes";
import * as api from "../api/index.js";
import { decryptData } from "../Components/utils/EncriptionStore";
 
 
const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
})();

export const toggleFavorite = (formData) => async (dispatch) => {
  try {
    const response = await api.toggleFavorite(formData);
    dispatch({
      type: TOGGLE_FAVORITE,
      payload: response.data,
    });
  } catch (error) {
    console.error("TOGGLE_FAVORITE error", error);
  }
};


export const fetchFavoriteInventory = () => async (dispatch) => {
  try {
    const response = await api.fetchFavoriteInventory({
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    });
    dispatch({
      type: FETCH_FAVORITE_INVENTORY,
      payload: response.data,
    });
  } catch (error) {
    console.error("FETCH_FAVORITE_INVENTORY error", error);
  }
};

export const deleteFavorites = (formData) => async (dispatch) => {
  try {
    const response = await api.deleteFavorites(formData);
    dispatch({
      type: DELETE_FAVORITES,
      payload: {
        name: formData.name, // manually include name
        content: response.data?.content, // if you have a success message
      },
    });
  } catch (error) {
    console.error("DELETE_FAVORITES error", error);
    throw new Error(
      error.response?.data?.detail || "Failed to delete favorite."
    );
  }
};
